import React, { useContext } from 'react';
import classes from './WhyShouldYouChooseUs.module.css';
import ChooseBlock from './ChooseBlock/ChooseBlock';
import circleBlue from './ChooseBlock/circleBlue.svg';
import circleYellow from './ChooseBlock/circleYellow.svg';
import circleRed from './ChooseBlock/circleRed.svg';
import { ThemeContext } from '../../App';

export default function WhyShouldYouChooseUs({
  containerSx,
}: {
  containerSx?: React.CSSProperties;
}) {
  const { theme } = useContext(ThemeContext);

  return (
    <div id={classes[theme]} className={classes.container} style={containerSx}>
      <h3 className="text-smBtwPages md:text-mdBtwPages lg:text-lgBtwPages text-center">
        Why choose us?
      </h3>
      <p className="text-smAddTxt hidden md:text-mdAddTxt lg:text-lgAddTxt lg:block text-center w-4/5 mx-auto">
        <strong>
          At FP Technologies we believe in true professionalism, flexibility,
          and scalability.
        </strong>{' '}
        Our work philosophy is deeply aligned with the values and objectives of
        our clients, enabling us to collaborate seamlessly as one unified team.
        This synergy empowers us to craft exceptional, dependable, long-term
        solutions that consistently exceed expectations.
      </p>
      <div
        className={
          classes.threeBlocks +
          ' flex flex-wrap lg:flex-nowrap flex-col lg:flex-row'
        }
      >
        <ChooseBlock
          image={chooseBlocksInfo[0].image}
          title={chooseBlocksInfo[0].title}
          content={chooseBlocksInfo[0].content}
        />
        <ChooseBlock
          image={chooseBlocksInfo[1].image}
          title={chooseBlocksInfo[1].title}
          content={chooseBlocksInfo[1].content}
        />
        <ChooseBlock
          image={chooseBlocksInfo[2].image}
          title={chooseBlocksInfo[2].title}
          content={chooseBlocksInfo[2].content}
        />
      </div>
    </div>
  );
}

const chooseBlocksInfo = [
  {
    image: circleBlue,
    title: 'We are Experts',
    content: `At FP Technologies, we excel at unlocking the full potential of data. Building products and services centered around data is essential across all business sectors, whether they're in the digital realm or involve physical products.`,
  },
  {
    image: circleYellow,
    title: 'We have extensive real word experience',
    content: `The wealth of experience enables us to deliver innovative and robust products that exceed industry standards. Our team of seasoned professionals has honed their skills over years of hands-on experience, creating cutting-edge native software solutions on the industry's most advanced public cloud platforms, including Amazon Web Services, Microsoft Azure, and Google Cloud Platform.`,
  },
  {
    image: circleRed,
    title: 'We are agile',
    content: `Data is dynamic, and products must continuously and swiftly evolve to meet clients' needs. At FP Technologies, we are agile in our approach, constantly refining our methods—an essential quality for delivering data products that provide true value to businesses.`,
  },
];
